// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__12QiM","author":"Table_author__3Fy0y","authorImage":"Table_authorImage__1m4ry","unreadRow":"Table_unreadRow__11mJn"};